import React, { FC } from 'react';
import { useStore } from 'react-redux';

import {
  logChatbotClickLink,
  logWixContactClickOnALinkInsideASolution,
  logWixContactClickOnTheActionButton,
} from '../../../bi';
import { TRootState } from '../../reducers';
import { Button } from '../Button';

interface Props {
  url: string;
  label: string;
  className: string;
}

export const AlertCTAButton: FC<Props> = ({ url, label, className }) => {
  const store = useStore<TRootState>();

  const clickHandler = () => {
    const state = store.getState();
    const params = {
      label,
      isCta: true,
      link: url,
    };

    logWixContactClickOnTheActionButton(state, params);
    logChatbotClickLink(state, params);
    logWixContactClickOnALinkInsideASolution(state, params);
  };

  return (
    <Button link={url} className={className} onClick={clickHandler}>
      {label}
    </Button>
  );
};
